import React, { Fragment, ReactNode } from 'react';
import styled from '@emotion/styled';
import { Donut, DonutData } from './shapes/Donut';

const Title = styled.div`
  padding-top: 1.25rem;
  padding-bottom: 1rem;
  font-size: 1.25rem;
  color: #566072;
  text-align: center;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  padding-bottom: 2rem;
  flex-wrap: wrap;
`;

const DonutWrapper = styled.div`
  flex: 3 0 128px;
  padding: 0.5rem;
`;
const LegendCircle = styled.div<{ color: string }>`
  height: 12px;
  width: 12px;
  background-color: ${p => p.color};
  border-color: ${p => p.color};
  border-width: 2px;
  border-style: solid;
  border-radius: 50px;
  display: inline-flex;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
  justify-self: center;
  align-self: center;
`;
const LegendItem = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  max-width: 140px;
  margin-bottom: 0.25rem;
`;
const LegendWrapper = styled.div`
  padding-left: 0.5rem;
  padding-right: 1rem;
  flex: 1 1 140px;
`;

interface DonutChartTileProps {
  title: ReactNode;
  data: DonutData[];
  percentage?: boolean;
}

export const DonutChartTile = ({ title, data, percentage }: DonutChartTileProps) => {
  return (
    <Fragment>
      <Title>{title}</Title>
      <Content>
        <LegendWrapper>
          {data.map(d => {
            return (
              <LegendItem key={d.color}>
                <div>
                  <LegendCircle color={d.color} />
                  {d.label}
                </div>
                <span>
                  {d.value}
                  {percentage && '%'}
                </span>
              </LegendItem>
            );
          })}
        </LegendWrapper>
        <DonutWrapper>
          <Donut data={data}></Donut>
        </DonutWrapper>
        <LegendWrapper />
      </Content>
    </Fragment>
  );
};

export default DonutChartTile;
